"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VueModel$installGlobalMixin = void 0;
var model_js_1 = require("@cognitoforms/model.js");
var helpers_1 = require("./helpers");
var vue_helpers_1 = require("./vue-helpers");
var vue_model_observability_1 = require("./vue-model-observability");
/**
 * Installs a global Vue mixin that hooks into component events to intercept model entities as component data and make necesary adjustments
 * @param Vue The Vue constructor/module object
 */
function VueModel$installGlobalMixin(Vue) {
    Vue.mixin({
        beforeCreate: function VueModel$Plugin$beforeCreate() {
            var vm = this;
            if (vm.$options.data) {
                // Intercept data that is an entity or data function that returns an entity
                // so that this plugin can make the entity observable and create proxy properties
                preprocessDataToInterceptEntities(vm);
            }
        },
        created: function VueModel$Plugin$created() {
            var vm = this;
            var vm$private = vm;
            if (vm$private._entity) {
                var entity = vm$private._entity;
                if (!entity.meta.type.model._entitiesAreVueObservable) {
                    // Ensure that Model entities are observable objects compatible with Vue's observer
                    (0, vue_model_observability_1.makeEntitiesVueObservable)(vm$private._entity.meta.type.model);
                }
                (0, vue_model_observability_1.getEntityObserver)(vm$private._entity, true).ensureObservable();
                // Restore the data by attempting to emulate what would have happened to
                // the `data` object had it gone through normal component intialization
                restoreComponentEntityData(vm);
            }
        }
    });
}
exports.VueModel$installGlobalMixin = VueModel$installGlobalMixin;
function replaceEntityData(vm, data) {
    var vm$private = vm;
    if (data != null && data instanceof model_js_1.Entity) {
        (0, helpers_1.debug)("Data is an entity, returning empty object...");
        vm$private._entity = data;
        return {};
    }
    return data;
}
function preprocessDataToInterceptEntities(vm) {
    if (!vm.$options.data) {
        return;
    }
    if (vm.$options.data instanceof Function) {
        // The `.data` options is a function that will be invoked by Vue, so wrap it
        // to prevent Vue from getting an Entity prior to setting up Entity observability
        (0, helpers_1.debug)("Data is a function...wrapping to intercept the return value...");
        var dataFn = vm.$options.data;
        vm.$options.data = function () {
            return replaceEntityData(vm, dataFn.apply(this, arguments));
        };
    }
    else {
        // Don't let Vue from getting an Entity prior to setting up Entity observability
        vm.$options.data = replaceEntityData(vm, vm.$options.data);
    }
}
function restoreComponentEntityData(vm) {
    var vm$private = vm;
    // Since the entity is now observable, go ahead and let the component see it
    // TODO: Is it necessary to somehow "merge" the object? Or, just not set the data
    //      field since we're going to do custom proxying of properties anyway?
    vm$private._data = vm$private._entity;
    // Vue proxies the data objects `Object.keys()` onto the component itself,
    // so that the data objects properties can be used directly in templates
    proxyEntityPropertiesOntoComponentInstance(vm, vm$private._entity);
    // The internal `observe()` method basically makes the given object observable,
    // (entities should already be at this point) but it also updates a `vmCount` counter
    (0, vue_model_observability_1.observeEntity)(vm$private._entity, true).ensureObservable();
    // Null out the field now that we've finished preparing the entity
    vm$private._entity = null;
}
function proxyEntityPropertiesOntoComponentInstance(vm, entity) {
    // TODO: add proxies onto the component instance
    // proxy data on instance
    var properties = entity.meta.type.properties;
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    for (var i = 0; i < properties.length; i++) {
        var property = properties[i];
        if (methods && (0, helpers_1.hasOwnProperty)(methods, property.name)) {
            (0, helpers_1.debug)("Property '" + property.name + "' is hidden by a component method with the same name.");
        }
        else if (props && (0, helpers_1.hasOwnProperty)(props, property.name)) {
            (0, helpers_1.debug)("Property '" + property.name + "' is hidden by a component prop with the same name.");
        }
        else if (!(0, vue_helpers_1.Vue$isReserved)(property.name)) {
            (0, vue_helpers_1.Vue$proxy)(vm, "_data", property.name);
        }
    }
}
